import { render } from "./ownerCompact.vue?vue&type=template&id=4cb04532"
import script from "./ownerCompact.vue?vue&type=script&lang=js"
export * from "./ownerCompact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__